import { render, staticRenderFns } from "./pinkShare.vue?vue&type=template&id=b7e114aa&scoped=true"
import script from "./pinkShare.vue?vue&type=script&lang=js"
export * from "./pinkShare.vue?vue&type=script&lang=js"
import style0 from "./pinkShare.vue?vue&type=style&index=0&id=b7e114aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e114aa",
  null
  
)

export default component.exports